const OPTIMIZABLE_HOSTS = new Set([
  "supabase.co",
  // add other hosts as they become canonical
]);

export function isOptimizable(url: string | null | undefined): boolean {
  if (!url) return true; // local /public assets are optimizable
  try {
    const u = new URL(url);
    if (u.protocol === "data:" || u.protocol === "blob:") return false;
    if (u.hostname === "localhost" || u.hostname.startsWith("127."))
      return true;
    for (const host of OPTIMIZABLE_HOSTS) {
      if (u.hostname.endsWith(host)) return true;
    }
    return false;
  } catch {
    return true; // relative path, optimizable
  }
}
